import React from 'react';

import { PageLayout } from '../PageLayout';
import { ContentsLayout } from '../ContentsLayout';

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <PageLayout>
      <ContentsLayout>{children}</ContentsLayout>
    </PageLayout>
  );
}
